module.exports = __webpack_public_path__ + "img/microphone.41524570.svg";